const stats = [
  { value: '10,000+', label: 'Students Placed' },
  { value: '500+', label: 'Hiring Partners' },
  { value: '95%', label: 'Placement Rate' },
  { value: '4.9', label: 'Average Rating', star: true },
];

function Impact() {
  return (
    <section id="impact" className="bg-brand-white py-10 lg:py-16">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="mx-auto mb-10 max-w-2xl text-center lg:mb-14">
          <p className="mb-3 text-label font-semibold uppercase tracking-[0.2em] text-[#F97316]">
            Our Impact
          </p>
          <h2 className="text-section leading-tight tracking-wide text-brand-navy sm:text-[36px]">
            Numbers That{' '}
            <span className="text-brand-primary">Matter</span>
          </h2>
          <div className="mx-auto mt-4 h-1 w-16 rounded-full bg-brand-primary" />
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {stats.map((stat) => (
            <article
              key={stat.label}
              className="rounded-2xl bg-brand-white px-6 py-8 text-center shadow-[0_12px_40px_-20px_rgba(17,22,44,0.28)]"
            >
              <p className="flex items-center justify-center gap-1 text-[32px] font-bold leading-none text-brand-primary sm:text-[36px]">
                {stat.value}
                {stat.star ? (
                  <svg viewBox="0 0 20 20" fill="currentColor" className="h-7 w-7 sm:h-8 sm:w-8" aria-hidden="true">
                    <path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.9l-4.94 2.61.94-5.5-4-3.9 5.53-.8L10 1.5z" />
                  </svg>
                ) : null}
              </p>
              <p className="mt-3 text-body-sm text-brand-muted">{stat.label}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Impact;
